export namespace AppConstants {
  export const UZURV_360_DRIVER_BUNDLE_IDENTIFIER = 'com.uzurv.uzurv360Driver';
  export const UZURV_RIDE_BUNDLE_IDENTIFIER = 'com.uzurv.uzurvRide';
  export const LEGACY_DRIVER_ANDROID_BUNDLE_IDENTIFIER = 'com.uzurv.android.driver';
  export const LEGACY_DRIVER_IOS_BUNDLE_IDENTIFIER = 'com.uzurv.Uzurv-Driver';
  export const CRM_BUNDLE_IDENTIFIER = 'com.uzurv.crm';
  export const ADMIN_BUNDLE_IDENTIFIER = 'com.uzurv.admin';
  export const REPORTS_BUNDLE_IDENTIFIER = 'com.uzurv.reports';
}
